<template>
  <div class="z1 bgfooter">
    <!-- <section id="patrocinadores" class="py-5">
      <div class="container">
        <div class="row">
          <div class="col-10 offset-1">
            <div
              class="row py-5 bg-white z1 roundedc"
              data-aos="fade-up"
              data-aos-delay="500"
            >
              <div class="col-12 text-center fG2 negro ls3 pb-5 pt-4">
                PRESENTADO POR
              </div>
              <div class="col-12 text-center fG2 negro ls3 py-2">
                <img
                  class="img-fluid"
                  src="../assets/imgs/copaprosa2023/logo-carnet.jpg"
                  alt="Patrocinadores"
                />
              </div>
              <div class="col-12 text-center fG2 negro ls3 py-2">
                <img
                  class="img-fluid"
                  src="../assets/imgs/copaprosa2023/pleca-footer.png"
                  alt="Patrocinadores"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <footer>
      <div class="container-fluid py-3">
        <div class="row  d-flex align-items-center">
          <div class="col-md-4 text-center pb-4 pb-md-0 pt-4 pt-lg-0">
            <router-link class="" to="/">
              <img
                class="img-fluid"
                src="../assets/imgs/copaprosa2024/logo-prosa-blanco.png"
                alt="Copa Prosa"
              />
            </router-link>
          </div>
          <div class="col-md-8 pt-4 pr-lg-5 d-flex justify-content-end text-center">
            <p class="blanco fC py-3">
              <router-link to="/aviso-de-privacidad" class="fC blanco"
                >AVISO DE PRIVACIDAD</router-link
              >
              | PROSA 2024
            </p>
          </div>

          
        </div>
      </div>
    </footer>

    <span class="loading" v-bind:class="{ active: this.$store.state.loading }">
      <img src="../assets/imgs/DualRing-1.1s-200px.svg" alt="loading" />
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

